import { createFileRoute } from "@tanstack/react-router";
import { browseDogsSearchRoute } from "@/app-clients/browse-dogs";

export const Route = createFileRoute("/search")({
    validateSearch: browseDogsSearchRoute.validateSearch,
    beforeLoad: browseDogsSearchRoute.beforeLoad,
});
